import { Inject, LOCALE_ID, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { AvailabilityService } from 'core-lib';
import { SettingsService } from 'core-lib';
import { formatCurrency } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';




@Pipe({
  name: 'displayPrice',
  standalone: true
})


/*
* Displays the price accoding to settings. price per night or price per stay,
* If price per night, calculate by days delta
* Transforms the result to currency by locale.
* Returns a span tag with per night translated to local language
* 
* NOTE: Needs to be used in innerHTML property of tag because the span tag will be escaped. 
* 
* TODO: Get currency from some setting rather than hard coded euro
*/

export class DisplayPricePipe implements PipeTransform, OnDestroy {

  daysDelta:number = 1;
  showPricePerNight:boolean = false;
  perNight:string = '';
  private subs: Subscription[] = []
  
  constructor(
    @Inject(LOCALE_ID) public locale: string,
    
    private avService: AvailabilityService, 
    private settings: SettingsService,
    private translate: TranslateService 
  ){
    try {
      this.daysDelta = this.avService.getSearchDaysDelta();
      this.showPricePerNight = this.settings.get("availability.showPricePerNight");
      this.subs.push(
        this.translate.get('av.night').subscribe((res:string) => {
          this.perNight = res;
        })
      );
      
    }
    catch(e) {
      console.error('Error in displayPricePipe: ', e);
    }
    
  }

  transform(value:any, digitsInfo:string = "1.2-2"): string|null {
    if (this.showPricePerNight) {
      return formatCurrency(parseFloat(value) / this.daysDelta, this.locale, "€", "EUR", digitsInfo) + '<span class="per-night">/'+this.perNight+'</span>';
    } 
    return formatCurrency(parseFloat(value), this.locale, "€", "EUR", digitsInfo);
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe())
  }

}
